package br.com.htms.inspeccaocampo.web

/**
 * Marca falha de boot no shell HTML (fora do pipeline Live Literals do Compose).
 */
fun reportWebBootFailure(message: String) {
    val apply: dynamic = js("(function(msg){ window['__ICD_BOOT_FAILED__']=true; window['__ICD_LAST_ERROR__']=String(msg||''); })")
    apply(message)
}
